
import axios from "axios";
import { serviceUrl } from "../../config";

const BACKEND_URL = serviceUrl;

export const createNewPortfolioUser = async (
  email,
  firstName,
  lastName,
  country,
  phoneno,
  gender,
  agentID,
  noEmail,
  userRole,
  filteredEntities,
  hasEntities
) => {
  try {
    const data = JSON.stringify({
      svc: "portfolio",
      pid: "createNewPortfolioUser",
      dat: {
        email: email,
        firstName: firstName,
        lastName: lastName,
        country: country,
        phoneno: phoneno,
        gender: gender,
        agentID: agentID,
        noEmail: noEmail,
        //logged in user === admin ? investor : delegate
        userRole: userRole,
        entities: filteredEntities,
        hasEntities: hasEntities
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log('Response from create new user-------->>>>>>', response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const PortfolioCreateFund = async (
  name,
  description,
  created_by,
  created_by_role,
  total_fund_size,
  minimum_ticket_size,
  target_multiple,
  target_yearly_return,
  associated_video_url,
  start_date,
  end_date,
  visibility,
  created_for
) => {
  try {
    const data = JSON.stringify({
      svc: "portfolio",
      pid: "PortfolioCreateFund",
      dat: {
       name: name,
        description: description,
        created_by: created_by,
        total_fund_size: total_fund_size,
        minimum_ticket_size: minimum_ticket_size,
        target_multiple: target_multiple,
        target_yearly_return: target_yearly_return,
        associated_video_url: associated_video_url,
        start_date: start_date,
        end_date: end_date,
        visibility: visibility,
        created_for: created_for,         
        created_by_role: created_by_role,
        tvpi: 0,
        dpi: 0,
        rvpi: 0
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};
export const PortfolioDownloadDocuments = async (docId) => {
  try {
    const data = JSON.stringify({
      svc: "portfolio",
      pid: "PortfolioDownloadDocuments",
      dat: {
        location: "",
        doc_id: docId,
        encryption_key: "",
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: { "Content-Type": "application/json" },
      data: data,
    };

    const response = await axios(config);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const PortfolioApplyFund = async (
  userId,
  userPin,
  fundId,
  investorId,
  requestedCommitment,
  notes,
) => {
  try {
    const data = JSON.stringify({
      svc: "portfolio",
      pid: "PortfolioApplyFund",
      dat: {
        location: "",
        userid: userId,
        userpin: userPin,
        fund_id: fundId,
        investor_id: investorId,
        requested_commitment: requestedCommitment,
        notes: notes,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: { "Content-Type": "application/json" },
      data: data,
    };

    const response = await axios(config);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
export const PortfolioUploadDocuments = async (
  fundId,
  fundName,
  file,
  accessRole,
  userId,
  userPin,
) => {
  try {
    const base64File = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result.split(",")[1]);
      reader.onerror = () => reject(new Error("File read failed"));
      reader.readAsDataURL(file);
    });

    const data = JSON.stringify({
      svc: "portfolio",
      pid: "PortfolioUploadDocuments",
      dat: {
        location: "",
        userid: userId,
        userpin: "4321",
        doctext: base64File,
        owner_type: "admin",
        owner_id: userId,
        document_type: file.type.includes("pdf") ? "pdf" : "other",
        display_name: file.name,
        fund_id: fundId,
        fund_name: fundName,
        access_role: accessRole || "public",
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: { "Content-Type": "application/json" },
      data: data,
    };

    const response = await axios(config);
    console.log(
      `PortfolioUploadDocuments response for ${file.name}:`,
      response.data,
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
export const PortfolioAdminBulkUpload = async (documents, userId, userPin) => {
  try {
    const documentItems = await Promise.all(
      documents.map(
        async ({
          file,
          ownerType,
          ownerId,
          fundId,
          documentType,
          displayName,
          accessRole,
          subFolder
        }) => {
          const base64File = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result.split(",")[1]);
            reader.onerror = () =>
              reject(new Error(`File read failed: ${file.name}`));
            reader.readAsDataURL(file);
          });

          return {
            doctext: base64File,
            owner_type: ownerType || "admin",
            owner_id: ownerId || userId,
            fund_id: fundId || "",
            document_type: documentType,
            display_name: displayName || file.name,
            access_role: accessRole || "public",
            sub_folder:    subFolder   || ''
          };
        },
      ),
    );

    const data = JSON.stringify({
      svc: "portfolio",
      pid: "PortfolioAdminBulkUpload",
      dat: {
        location: "",
        userid: userId,
        userpin: userPin || "4321",
        documents: {
          item: documentItems,
        },
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: { "Content-Type": "application/json" },
      data: data,
    };

    const response = await axios(config);
    console.log("PortfolioBulkUpload response:", response.data);
    return response.data;
  } catch (error) {
    console.error("PortfolioBulkUpload error:", error);
    throw error;
  }
};
export const PortfolioGetFolderStructure = async (userId,
  userRole,
) => {
  try {
    const data = JSON.stringify({
      svc: "portfolio",
      pid: "PortfolioGetFolderStructure",
      dat: {
        userid: userId,
        //logged in user === admin ? admin: investor
        user_role: userRole
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};
export const PortfolioAssignDelegate = async (
  location,
  investor_id,
  delegate_id,
) => {
  try {
    const data = JSON.stringify({
      svc: "portfolio",
      pid: "PortfolioAssignDelegate",
      dat: {
        location: location,
        investor_id: investor_id,
        delegate_id: delegate_id,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};
export const PortfolioReviewApplication = async (
  location,
  userid,
  application_id,
  new_status,
  notes
) => {
  try {
    const data = JSON.stringify({
      svc: "portfolio",
      pid: "PortfolioReviewApplication",
      dat: {
        location: location,
        userid: userid,
        application_id: application_id,
        new_status: new_status,
        notes: notes
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};
export const PortfolioGetDelegateOverview = async (location,
  userid,
) => {
  try {
    const data = JSON.stringify({
      svc: "portfolio",
      pid: "PortfolioGetDelegateOverview",
      dat: {
        userid: userid,
        location: location
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const PortfolioDeleteDocuments = async (
  payload,
) => {
  try {
    const data = JSON.stringify({
      svc: "portfolio",
      pid: "PortfolioDeleteDocuments",
      dat: {
        file_keys: payload
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const PortfolioRenameFolder = async (
  oldPath,
  newPath
) => {
  try {
    const data = JSON.stringify({
      svc: "portfolio",
      pid: "PortfolioRenameFolder",
      dat: {
        old_path: oldPath,
        new_path: newPath
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

